<template>
  <div class="newsdetails">
    <div class="location-list">
      <div style="padding-left:1.042rem">
        <!-- <img src="@/assets/img/details/current.png" alt=""> -->
        当前位置：
      </div>
      <el-breadcrumb separator="/" separator-class="el-icon-minus">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻</el-breadcrumb-item>
        <el-breadcrumb-item style="color:#b1222b;">{{bookTitle}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="news-info">
      <div class="news-nav">
        <p class="news-title">{{bookTitle}}</p>
        <!--<div class="news-time">
          <span>时间：</span> <span>{{$store.getters.unixTime(newItem.publishTime)}}</span>
          &lt;!&ndash; <span style="margin-left:1rem">作者：</span> <span>{{}}</span> &ndash;&gt;
        </div>-->
      </div>
      <div class="news-text">
        <p class="ql-editor text" v-html="newItem.content"></p>
        <!-- <div  class="news-img" :style="'background:url('+ Img +') no-repeat'"></div> -->
        <!--        <img :src="Img" alt="" class="news-img">-->
      </div>
    </div>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import {getContentById} from "../../utils/router/news.api";

  export default {
    data() {
      return {
        bookTitle: "",
        newItem: [],
        newsList: [],
        Img: '',
      };
    },
    methods: {
      getInfo() {
        let id = this.$route.query.id;
        getContentById({id: id}).then((res) => {
          if (res && res.data.code === 200) {
            this.bookTitle = res.data.data.title;
            this.newItem = res.data.data;
          } else {
            this.$alert("获取失败！" + res.data.message);
          }
        });
      },
    },
    created() {
      this.getInfo();
      this.newsList = JSON.parse(sessionStorage.getItem("newsdata"));
      this.newsList.map((data) => {
        if (data.id == this.$route.query.id) {
          this.Img = data.banner;
        }
      });
    },
  };
</script>

<style lang="less" scoped>
  .newsdetails {
    width: 62.5rem;
    padding-top: 1.042rem;
    margin: auto;

    .location-list {
      height: 2.604rem;
      background: #fff;
      display: flex;
      font-size: 0.833rem;
      // font-weight: 700;
      padding-top: 0.885rem;

      .el-breadcrumb {
        font-size: 0.833rem;
        // line-height: 1.25;
      }

      /deep/ .el-breadcrumb__inner.is-link {
        font-weight: 100 !important;
      }
    }

    .news-info {
      background: #fff;
      padding: 0 1.51rem;
      margin-top: 0.625rem;
      text-align: center;

      .news-nav {
        height: 6.719rem;
        border-bottom: 0.052rem solid #ddd;
        padding-top: 1.979rem;

        .news-title {
          font-size: 1.25rem;
          font-weight: bold;
        }

        .news-time {
          color: #909090;
          font-size: 0.833rem;
          margin-top: 1.28rem;
        }
      }

      .news-text {
        font-size: 0.833rem;
        padding: 1.771rem 0;
        line-height: 26px;
        text-indent: 2rem;
        text-align: left;
        margin-bottom: 2.083rem;
        .ql-editor.text{
          /deep/p{
            text-align: center;
            img{
              max-width: 57rem;
            }
          }

        }
      }

      .news-img {
        width: 59.375rem;
        height: 32.396rem;
        background-size: 100%;
        margin: 0.563rem 0;
      }
    }
  }
</style>
